import React from "react";
import CircularProgress from "../CircularProgress";
import { Container, Hero, HeroCta, CtaTitle, CtaDetails } from "./styles";

const StrategiesHero = ({ percentage, cta, details, onPress }) => {
	return (
		<Container>
			<Hero hasDetails={details}>
				<CircularProgress percent={percentage}></CircularProgress>
				<CtaTitle type="mono3">{cta}</CtaTitle>
			</Hero>
			{details && (
				<HeroCta onPress={onPress}>
					<CtaDetails type="ctah4">{details}</CtaDetails>
				</HeroCta>
			)}
		</Container>
	);
};

export default StrategiesHero;
